import { useCallback } from 'react';
import type { MotionBlurValue } from '../../lib/filters/motion-blur';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Motion Blur panel — angle (0..360°) and distance (0..200 px).
 *  Two sliders rather than the Photoshop angle-dial widget; the
 *  dial is nicer but the slider is keyboard-accessible by default
 *  and matches every other panel in the editor. */
export function MotionBlurPanel({ value, onChange }: AdjustmentPanelProps<MotionBlurValue>) {
  const set = useCallback(
    (patch: Partial<MotionBlurValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Angle"
        min={0}
        max={360}
        step={1}
        value={value.angle}
        onChange={(v) => set({ angle: v })}
      />
      <RangeRow
        label="Distance"
        min={0}
        max={200}
        step={1}
        value={value.distance}
        onChange={(v) => set({ distance: v })}
      />
    </div>
  );
}
